import {
    PROFILE_EDIT,
} from 'actions';

const initialState = {
    profile: null,
    isValid: true,
    isEdited: false,
};

export default (state = initialState, action) => {
    const {profile, isValid, isEdited, type} = action;
    switch (type) {
        case PROFILE_EDIT:
            return {
                ...state,
                profile,
                isValid,
                isEdited,
            };

        default:
            return state;
    }
};
